<template>
  <div class="recharge_left capital_first" v-if="central_ucenter_transfer_status == 1">
    <el-card class="box-card common-bg" shadow="never">
      <div slot="header" class="clearfix">
        <el-col :span="12">
          <h3>资金划转 </h3>
        </el-col>
      </div>
      <el-tabs>
        <el-tab-pane id="isFromCoupon1">
          <h4 slot="label"> 资金划转</h4>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row>
                <!-- Current Asset -->
                <el-col :span="5" style="text-align: center;line-height: 36px" class="common_border">
                  <h3>当前资产 </h3>
                  <p class="text_red_color" style="font-size: 16px;">{{ cash }}</p>
                </el-col>

                <!-- DNHK -->
                <el-col :span="5" style="text-align: center;line-height: 30px;margin-left:20px;" class="common_border">
                  <h5 style="font-weight: 200;margin-bottom: 3px;">金牛港股</h5>
                  <el-button
                    type="primary"
                    class="button_blue_color"
                    @click="openMoveOut('JNHK')"
                  >
                    划转
                  </el-button>
                </el-col>

                <!-- DNUS -->
                <el-col :span="5" style="text-align: center;line-height: 30px;margin-left:20px;" class="common_border">
                  <h5 style="font-weight: 200;margin-bottom: 3px;">金牛美股</h5>
                  <el-button
                    type="primary"
                    class="button_blue_color"
                    @click="openMoveOut('JNUS')"
                  >
                    划转
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane id="isFromCoupon2">
          <h4 slot="label">账单</h4>
          <el-card>
            <el-form :inline="true" size="mini">
              <el-form-item label="日期">
                <el-date-picker
                  v-model="platformTransferDetails.date"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="button_blue_color" @click="getPlatformTransferDetails">检索</el-button>
              </el-form-item>
            </el-form>
          <el-table :data="platformTransferDetails.data" size="mini" stripe style="width: 100%">
            <el-table-column width="140" prop="order" align="center" label="订单号"></el-table-column>
            <el-table-column width="160" prop="reference_number" align="center" label="中央系统编号"></el-table-column>
            <el-table-column width="120" prop="number" align="center" label="划转额"></el-table-column>
            <el-table-column width="120" prop="balance" align="center" label="账户余额"></el-table-column>
            <el-table-column width="130" prop="type" align="center" label="划转操作类型">
              <template slot-scope="scope">
                <span
                  :style="{
                    color:
                      scope.row.type === '转入'
                        ? '#3f7a21'   
                        : scope.row.type === '转出'
                        ? '#D02E27'  
                        : '#0D268D'   
                  }"
                >
                  {{ scope.row.type }}
                </span>
              </template>
            </el-table-column>
            <el-table-column width="100" prop="status" align="center" label="状态">
              <template slot-scope="scope">
                <span
                  :style="{
                    color:
                      scope.row.status === '成功'
                        ? '#3f7a21'   
                        : scope.row.status === '失败'
                        ? '#D02E27'  
                        : '#0D268D'   
                  }"
                >
                  {{ scope.row.status }}
                </span>
              </template>
            </el-table-column>
            <el-table-column width="130" prop="request_platform" align="center" label="访问平台"></el-table-column>
            <el-table-column width="180" prop="time" align="center" label="创建时间"></el-table-column>
          </el-table>

            <div class="changePage" style="padding-top: 15px;">
              <el-button
                type="primary"
                class="button_blue_color"
                icon="el-icon-arrow-left"
                @click="prevPlatformTransferDetails"
                size="mini"
              >
                上一页
              </el-button>
              <el-button
                type="primary"
                class="button_blue_color"
                icon="el-icon-arrow-right"
                @click="nextPlatformTransferDetails"
                size="mini"
                style="float: right"
              >
                下一页
              </el-button>
            </div>
          </el-card>
          <div
            style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;"
          >
            只显示最近12个月记录
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- DIALOG: TRANSFER OUT -->
    <el-dialog
      class="platform_transfer_popup"
      :title="`划转至 ${selectedPlatformText || 'Other Platform'}`"
      :visible.sync="moveOutState"
    >
      <el-form ref="form" size="small" label-position="left" class="custom-transfer-form" label-width="120px">
        <el-form-item label="账户余额">
          <!-- <h4 slot="label">账户余额:</h4> -->
          <p>{{ cash }} 元</p>
        </el-form-item>

        <el-form-item label="划转">
          <!-- <h4 slot="label">划转:</h4> -->
          <el-input
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="moveOutAmount"
            placeholder=""
            @input="calculateExchangeRate"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="row" style="display: flex;" v-if="hk_exchange_ratio>0 && selectedPlatform=='JNHK'">
         <div class="col-md-8" style="display: flex;">
              </div>
            <div class="col-md-8" style="display: flex;" >
              <h5 slot="label">RMB : HKD = 1:<span>{{ hk_exchange_ratio }}</span> </h5>
            </div>
             <div class="col-md-8" style="display: flex;">
              &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
             <div class="col-md-8" style="display: flex;" >
              <h5 slot="label" >到账金额 = <span>{{ hk_exchange_amount }}</span>港元 </h5>
            </div>
          </div>
            <div class="row" style="display: flex;" v-if="us_exchange_ratio>0 && selectedPlatform=='JNUS'">
         <div class="col-md-8" style="display: flex;">
              </div>
            <div class="col-md-8" style="display: flex;" >
              <h5 slot="label">RMB : USD = 1:<span>{{ us_exchange_ratio }}</span> </h5>
            </div>
             <div class="col-md-8" style="display: flex;">
              &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
             <div class="col-md-8" style="display: flex;" >
              <h5 slot="label">到账金额 = <span>{{ us_exchange_amount }}</span>美元</h5>
            </div>
          </div>
      <div slot="footer" class="dialog-footer half-buttons">
        <el-button @click="moveOutState = false">取消</el-button>
        <el-button type="primary" class="button_blue_color" @click="moveout">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "platformTransfer",
  data() {
    return {
      amount: 0,
      cash: 0,
      moveInAmount: 0,
      annual_interest_rate: 0,
      moveOutAmount: 0,
      moveInState: false,
      moveOutState: false,
      central_ucenter_transfer_status: 0,
      platformTransferDetails: {
        date: [],
        data: [],
        page: 1,
        num: 20
      },
      platform: "",
      selectedPlatform: "", 
      selectedPlatformText : "",
      selectedPlatformBalance: 0,
      availablePlatforms: [
        { label: "JNHK", value: "JNHK", balance: 0 },
        { label: "JNUS", value: "JNUS", balance: 0 }
      ],
      hk_exchange_ratio:0,
      us_exchange_ratio:0,
      hk_exchange_amount:0,
      us_exchange_amount:0
    };
  },
  methods: {
    calculateExchangeRate(value){
      if(this.selectedPlatform=='JNHK'){
           this.hk_exchange_amount=(value*this.hk_exchange_ratio).toFixed(2);
      }
      else if(this.selectedPlatform=='JNUS'){
           this.us_exchange_amount=(value*this.us_exchange_ratio).toFixed(2);
      }
    },
    getExchangeRatio(selectdPlt){
      let that=this;
      var transfer_plt=selectdPlt=='JNUS'?'USD':'HKD';
       that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "platform_transfer",
            token: sessionStorage.getItem("token"),
            action: "transaction_ratio",
            from: "RMB",
            to: transfer_plt
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            if(transfer_plt=='HKD'){
              that.hk_exchange_ratio=res.data.data;
            }else{
              that.us_exchange_ratio=res.data.data;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });

    },
    openMoveOut(platform) {
      this.selectedPlatform = platform;
      if (platform === "JNHK") {
        this.selectedPlatformText = "金牛港股";   
      } else if (platform === "JNUS") {
        this.selectedPlatformText = "金牛美股";
      } else {
        this.selectedPlatformText = "Other Platform";
      }
      this.getExchangeRatio(platform);
      this.us_exchange_amount=0;
      this.hk_exchange_amount=0;
      this.moveOutAmount = 0;
      this.moveOutState = true;
    },

    getPlatformTransferDetails() {
      let that = this;

      const requestData = {
        nozzle: "platform_transfer",
        token: sessionStorage.getItem("token"),
        action: "transaction_log",
        page: that.platformTransferDetails.page,
        num: that.platformTransferDetails.num
      };

      if (that.platformTransferDetails.date && that.platformTransferDetails.date.length === 2) {
        requestData.start = that.platformTransferDetails.date[0];
        requestData.end = that.platformTransferDetails.date[1];
      }

      that
        .$http({
          url: "/",
          method: "post",
          data: requestData
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            that.platformTransferDetails.data = resData.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取用户信息
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.cash = res.data.data.cash;
            that.moveInAmount = that.cash;
            that.moveOutAmount = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getCentralTransferStatus() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "central_ucenter_transfer_status"
          }
        })
        .then(function(res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.central_ucenter_transfer_status = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    prevPlatformTransferDetails() {
      let page = this.platformTransferDetails.page;
      if (page == 1) {
        this.$message({
          message: '已经是第一页',
          type: 'warning'
        });
      } else {
        this.platformTransferDetails.page = page - 1;
        this.getPlatformTransferDetails();
      }
    },
    nextPlatformTransferDetails() {
      let page = this.platformTransferDetails.page;
      if (this.platformTransferDetails.length < 20) {
        this.$message({
          message: '已经是最后一页',
          type: 'warning'
        });
      } else {
        this.platformTransferDetails.page = page + 1;
        this.getPlatformTransferDetails();
      }
    },

    moveout() {
      let that = this;
      let money = that.moveOutAmount;
      let request_platform = that.selectedPlatform;

      if (!request_platform) {
        that.$message.error("Platform is not selected");
        return;
      }

      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "platform_transfer",
            token: sessionStorage.getItem("token"),
            action: "transferout",
            amount: money,
            request_platform: request_platform
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.moveOutState = false;
            that.$message({
              message: res.data.msg,
              type: "success",
              onClose: function() {
                // reload data
                that.mainMethod();
              }
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },

    mainMethod() {
      this.getPlatformTransferDetails();
      this.getUserinfo();
    }
  },
  mounted() {
    this.getCentralTransferStatus();
    this.getPlatformTransferDetails();
    this.getUserinfo();
  }
};
</script>

<style scoped>

 .half-buttons {
   display: flex;
 }
 
 .half-buttons .el-button {
   width: 50%;
 }

/deep/ .el-tabs__item.is-active {
  color: #0D268D !important;
}

/deep/ .el-tabs__item:hover {
  color: #0D268D !important;
}

/deep/ .el-tabs__active-bar {
  background-color: #0D268D !important;
}

/deep/ .common_border1 {
  padding: 15px !important;
}


</style>

<style>
.platform_transfer_popup .el-dialog {
  width: 25% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/platformTransfer.vue